import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../top-bar/top-bar";
import { AdminsIcon, AthletesIcon, BackIcon } from "../modals/icons/icons";
import { instance } from "../../../utils/utils";

export default function SubscriptionAction() {
    const navigate = useNavigate();
    const location = useLocation();

    const initialPlanData = location.state?.planData || null;
    const initialAction = location.state?.action || "cancel";

    const [planData, setPlanData] = useState(initialPlanData);
    const [action, setAction] = useState(initialAction);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!planData) {
            fetchPlanData();
        }
    }, []);

    const fetchPlanData = async () => {
        setLoading(true);
        try {
            const res = await instance.get("/customers/company/plan/detail");
            setPlanData(res.data);
        } catch (err) {
            console.error("Error obteniendo plan detail:", err);
        } finally {
            setLoading(false);
        }
    };


    const handleCancelSubscription = async () => {
        setLoading(true);
        try {
            await instance.post("/customers/company/plan/cancel");
            setAction("renovate");
        } catch (error) {
            console.error("Error al cancelar suscripción:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleReactivateSubscription = async () => {
        setLoading(true);
        try {
            await instance.post("/customers/company/plan/cancel");
            navigate("/admin/edit-member");
        } catch (error) {
            console.error("Error al reactivar suscripción:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="w-100">
            <Topbar />
            <div className="subscription-edit-container subscription-action-cancel w-100 p-3 px-5 gap-4 gap-xxl-5 d-flex flex-column">

                <div className="subscription-edit-header d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-start gap-2">
                        <div className="subscription-edit-title mb-0 d-flex flex-row align-items-start gap-2 cursor-pointer" onClick={() => navigate(action === "cancel" ? "/admin/edit-member" : "/admin/")}>
                            <BackIcon />
                            <div className="subscription-edit-title d-flex flex-column">
                                <span>Gestión de Suscripción</span>
                                <small>--</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row gx-4">
                    <div className="col-lg-7">

                        <div className="subscription-edit-current-plan card mb-4 p-3">
                            <div className="w-100 d-flex flex-row justify-content-between align-items-start">
                                <div className="d-flex flex-column align-self-center gap-2">
                                    <h5 className="subscription-edit-current-title mb-0">Tu plan actual</h5>
                                    <h4 className="subscription-edit-plan-name mb-0">
                                        {planData?.plan_title}{" "}
                                        <span className="subscription-edit-plan-tag">
                                            ({planData?.current_payment_form?.includes("Anual") ? "Anual" : "Mensual"})
                                        </span>
                                    </h4>
                                    <span className="subscription-edit-renew">
                                        {action === "cancel" ? "Fecha de renovación: " : "Fecha de cancelación: "}{planData?.next_payment_due_date}
                                    </span>
                                </div>

                                <div className="text-end subscription-edit-meta d-flex flex-column align-items-start gap-2">
                                    <span className="subscription-edit-meta-status">
                                        {planData?.is_trial ? "Prueba Gratuita" : "Contratado"}
                                    </span>
                                    <div className="subscription-edit-meta-athletes">
                                        <AthletesIcon />
                                        {planData?.client_slots_used} / {planData?.contracted_client_slots} Atletas
                                    </div>
                                    <div className="subscription-edit-meta-athletes">
                                        <AdminsIcon />
                                        {planData?.admin_slots_used} / {planData?.contracted_admin_users} Admins
                                    </div>
                                </div>
                            </div>
                        </div>

                        {action === "cancel" ? (
                            <div className="subscription-customize-card mb-4">
                                <div className="subscription-customize-card-icon d-flex justify-content-center align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                                        <circle cx="19" cy="19" r="14.25" stroke="#F93232" stroke-width="2" />
                                        <path d="M19.7904 11.8737C19.7904 12.3109 19.4359 12.6654 18.9987 12.6654C18.5615 12.6654 18.207 12.3109 18.207 11.8737C18.207 11.4365 18.5615 11.082 18.9987 11.082C19.4359 11.082 19.7904 11.4365 19.7904 11.8737Z" fill="#F93232" stroke="#F93232" />
                                        <path d="M19 26.9154V15.832" stroke="#F93232" stroke-width="2" />
                                    </svg>
                                </div>
                                <div className="subscription-customize-card-title">
                                    ¿Estás seguro de cancelar?
                                </div>
                                <div className="subscription-customize-card-description">
                                    Perderás tu tarifa actual y el acceso histórico.
                                </div>
                                <div className="subscription-customize-card-buttons d-flex flex-row justify-content-center align-items-center gap-2">
                                    <button className="btn btn-outline-primary" onClick={() => navigate("/admin/edit-member")}>No, volver</button>
                                    <button className="btn btn-primary" onClick={handleCancelSubscription}>Sí, cancelar</button>
                                </div>
                            </div>
                        ) : (
                            <div className="subscription-customize-reactivate mb-4">
                                <div className="subscription-customize-reactivate-header"></div>

                                <div className="p-3 d-flex flex-column align-items-center gap-3">
                                    <div className="subscription-customize-reactivate-icon d-flex justify-content-center align-items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                                            <path d="M19 33.25C17.1287 33.25 15.2756 32.8814 13.5468 32.1653C11.8179 31.4492 10.247 30.3995 8.92373 29.0763C7.60049 27.753 6.55085 26.1821 5.83472 24.4532C5.11859 22.7243 4.75 20.8713 4.75 19C4.75 17.1287 5.11859 15.2756 5.83472 13.5468C6.55085 11.8179 7.60049 10.247 8.92373 8.92373C10.247 7.60049 11.8179 6.55084 13.5468 5.83472C15.2757 5.11859 17.1287 4.75 19 4.75C20.8713 4.75 22.7244 5.11859 24.4532 5.83472C26.1821 6.55085 27.753 7.6005 29.0763 8.92373C30.3995 10.247 31.4492 11.8179 32.1653 13.5468C32.8814 15.2757 33.25 17.1287 33.25 19C33.25 20.8713 32.8814 22.7244 32.1653 24.4532C31.4492 26.1821 30.3995 27.753 29.0763 29.0763C27.753 30.3995 26.1821 31.4492 24.4532 32.1653C22.7243 32.8814 20.8713 33.25 19 33.25L19 33.25Z" stroke="#394F65" stroke-width="2" stroke-linecap="round" />
                                            <path d="M14.25 14.25L23.75 23.75" stroke="#394F65" stroke-width="2" stroke-linecap="round" />
                                            <path d="M23.75 14.25L14.25 23.75" stroke="#394F65" stroke-width="2" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                    <div className="subscription-customize-reactivate-title">
                                        Cancelación Programada
                                    </div>
                                    <div className="subscription-customize-reactivate-description d-flex flex-column gap-1">
                                        Tu suscripción cuenta con una cancelación programada.
                                        <span className="subscription-customize-reactivate-description">
                                            El servicio permanecerá activo hasta que el proceso concluya de manera automática.
                                        </span>
                                    </div>
                                    <div className="subscription-customize-reactivate-status">
                                        <div className="subscription-customize-reactivate-status-title">
                                            Estado
                                        </div>
                                        <div className="subscription-customize-reactivate-status-description">
                                            Pendiente de finalización
                                        </div>

                                        <div className="subscription-customize-reactivate-status-title">
                                            Fecha de cancelación
                                        </div>
                                        <div className="subscription-customize-reactivate-status-description">
                                            {planData?.next_payment_due_date}
                                        </div>
                                    </div>
                                    <div className="subscription-customize-reactivate-buttons d-flex flex-row justify-content-center align-items-center gap-2">
                                        <button className="btn btn-primary" onClick={handleReactivateSubscription}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M9 10L5 14L1 10" stroke="white" stroke-width="2" />
                                                <path d="M8.5 18.0622C9.83449 18.8326 11.3859 19.1412 12.9137 18.9401C14.4414 18.739 15.8601 18.0394 16.9497 16.9497C18.0394 15.8601 18.739 14.4414 18.9401 12.9137C19.1412 11.3859 18.8326 9.83449 18.0622 8.5C17.2917 7.16551 16.1024 6.12254 14.6788 5.53284C13.2551 4.94315 11.6767 4.83969 10.1883 5.23852C8.69983 5.63734 7.38459 6.51616 6.44653 7.73867C5.50846 8.96118 5 10.4591 5 12" stroke="white" stroke-width="2" stroke-linecap="round" />
                                            </svg>
                                            Me arrepentí, reactivar plan
                                        </button>
                                    </div>
                                    <span className="subscription-customize-reactivate-description"><small>Al reactivar, mantendrás tus condiciones actuales sin cambios.</small></span>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="col-lg-5 d-flex flex-column justify-content-center align-items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="95" height="95" viewBox="0 0 95 95" fill="none">
                            <path d="M44.3828 12.8623C46.3742 12.0088 48.6287 12.0088 50.6201 12.8623L74.0312 22.8955C77.2738 24.2854 79.2052 27.6536 78.7676 31.1543L76.3418 50.5654C75.4703 57.5366 71.9829 63.9164 66.5859 68.4141L52.5693 80.0947C49.6336 82.5411 45.3694 82.5409 42.4336 80.0947L28.417 68.4141C23.0199 63.9164 19.5326 57.5367 18.6611 50.5654L16.2344 31.1543C15.7968 27.6535 17.7289 24.2853 20.9717 22.8955L44.3828 12.8623Z" stroke="#DFDFDF" stroke-width="7.91667" stroke-linecap="round" />
                            <path d="M35.6237 47.5L45.7916 57.6679C46.6747 58.551 48.1451 58.4055 48.8379 57.3663L63.332 35.625" stroke="#DFDFDF" stroke-width="7.91667" stroke-linecap="round" />
                        </svg>

                        <div className="subscription-customize-card-description w-75">

                            Los detalles de pago no están disponibles durante el proceso de cancelación.

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
